import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./index.css";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import PhoneIcon from "@material-ui/icons/Phone";
import EventsIcon from "assets/svg_icons/events_icon.svg";
import { GoPeople } from "react-icons/go";
import { TbSmartHome } from "react-icons/tb";
import { PiChatsCircle } from "react-icons/pi";
import { MdArrowBackIos, MdArrowForwardIos } from "react-icons/md";
import { THERAPIST_CHATS, THERAPIST_EVENTS, THERAPIST_MY_CLIENTS, THERAPIST_MY_PROFILE, THERAPIST_MY_SESSIONS } from "./Dashboard/TherapistDashboard";
import { useUserInfoSelector } from "store/reducers";

const avatar = {
  female: "https://ucarecdn.com/c22b8f55-8c68-411e-a5c9-8b5b99c08701/femaleEmoji.svg",
  male: "https://ucarecdn.com/52c99efd-cba4-4fe1-93f2-e393088b7a0c/male.svg",
  other: "https://ucarecdn.com/c7bb4c01-2258-428d-b8ce-e2196ee63220/lgbtq.svg",
};

const LeftMenuTherapist = ({ activeComponent,  compressMenu, setActiveComponent, handleLogout, showSessions, showChats, showClients, showProfile, showEvents }) => {
  const location = useLocation();
  const [compressLeftmenu, setCompressLeftmenu] = useState(false);
  const userInfo = useUserInfoSelector();


  const toggleCompressMenu = () => {
    setCompressLeftmenu(!compressLeftmenu);
    if (typeof compressMenu === "function") {
      compressMenu(!compressLeftmenu);
    }
  };

  const isActive = (path ) => path === activeComponent ? "therapistTabActive" : "";

  return (
    <div className={compressLeftmenu ? "left-menustuff therapist compress" : "left-menustuff therapist"}>
      <div className="leftmenu-head">
        <p className="title-lms">
          GoodLives<sup>TM</sup>
        </p>
        <div className={compressLeftmenu ? "compress-div active" : "compress-div"} onClick={toggleCompressMenu}>
          {compressLeftmenu ? <MdArrowForwardIos color={"white"} size={15} /> : <MdArrowBackIos color={"white"} size={20} />}
        </div>
      </div>
      <div className="content-lms">
        <ul>
          <li className={isActive(THERAPIST_MY_SESSIONS)} onClick={showSessions}>
            <TbSmartHome className="menu-icon" size={25} /> <p>My Sessions</p>
          </li>
          <li className={isActive(THERAPIST_CHATS)} onClick={showChats}>
            <PiChatsCircle className="menu-icon" size={25} /> <p>Chats</p>
          </li>
          <li className={isActive(THERAPIST_MY_CLIENTS)} onClick={showClients}>
            <GoPeople className="menu-icon" size={25} /> <p>My Clients</p>
          </li>
          <li className={isActive(THERAPIST_EVENTS)} onClick={showEvents}>
            <img src={EventsIcon} className="menu-icon" /><p>Events</p>
          </li>
          <li className={isActive(THERAPIST_MY_PROFILE)} onClick={showProfile}>
            <img src={userInfo?.avatar_url || avatar[userInfo?.gender || "other"]} className="menu-icon" alt="Profile" /> <p>My Profile</p>
          </li>
        </ul>
      </div>
      <div className="th-signout" onClick={handleLogout}>
        <ExitToAppIcon /> <p>Sign Out</p>
      </div>
    </div>
  );
};

export default LeftMenuTherapist
